(() => {
  // Older shared search URLs have no result type. Keep the default Products
  // tab consistent with Shopify's results without changing article searches.
  const searchUrl = new URL(window.location.href);
  if (searchUrl.searchParams.has('q') && !searchUrl.searchParams.has('type')) {
    searchUrl.searchParams.set('type', 'product');
    window.location.replace(searchUrl.href);
    return;
  }

  document.querySelectorAll('[data-search-tabs]').forEach(tabs => {
    tabs.querySelectorAll('[data-search-type]').forEach(async link => {
      if (link.querySelector('[data-search-count]').textContent.trim()) return;
      const url = new URL(link.href);
      url.searchParams.set('section_id', 'dut-search-count');
      try {
        const response = await fetch(url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const count = doc.querySelector('[data-result-count]')?.dataset.resultCount;
        if (count !== undefined) link.querySelector('[data-search-count]').textContent = ` (${count})`;
      } catch (_) { /* Keep the native search link usable if counting is unavailable. */ }
    });
  });

})();
